$('.breadcrumbs #navigation-first a span').text('Vyspimese.CZ');    